export function filtrarCoordenadas(coordenadas: any[], precisao: 'baixo' | 'medio' | 'alto'): any[] {
  switch (precisao) {
    case 'baixo':
      return coordenadas.filter((_, index) => index % 3 === 0); // Pega 1, pula 2
    case 'medio':
      return coordenadas.filter((_, index) => index % 2 === 0); // Pega 1, pula 1
    case 'alto':
      return coordenadas; // Exibe todos
    default:
      return coordenadas;
  }
}


export const latitudeLongitudeValida = (latitude: string, longitude: string): boolean => {
  const isValidNumber = (value: string) => /^-?\d+(\.\d+)?$/.test(value);

  // 1. Verificação de nulo/vazio
  if (!latitude || !longitude) {
    console.warn('🗺️ Coordenada rejeitada: Latitude ou Longitude ausente ou vazia.', { latitude, longitude });
    return false;
  }

  // 2. Regra de negócio (evita cair no meio do oceano / Null Island)
  if (latitude.trim() === '0' || longitude.trim() === '0') {
    console.warn('🗺️ Coordenada rejeitada: Valores zerados.', { latitude, longitude });
    return false;
  }

  // 3. Validação de formato (barra letras, vírgulas ou sujeira no texto)
  if (!isValidNumber(latitude) || !isValidNumber(longitude)) {
    console.warn('🗺️ Coordenada rejeitada: Formato inválido (verifique se há vírgulas em vez de pontos).', { latitude, longitude });
    return false;
  }

  const lat = parseFloat(latitude);
  const lon = parseFloat(longitude);

  // 4. Limites de renderização do Google Maps (Web Mercator)
  // Reduzido para 85 / -85 para evitar o travamento da tela marrom
  if (lat < -85 || lat > 85 || lon < -180 || lon > 180) {
    console.warn('🗺️ Coordenada polar rejeitada para evitar quebra de renderização do mapa:', { latitude, longitude });
    return false;
  }
  return true;
};
